import { ChartType } from '../../../../pages/Summary/Components/Charts/ChartTypes.ts';
import GraphViewControlBar from '../GraphViewControlBar.tsx';

/**
 * AssetCategoryType - Component for rendering the GraphViewControlBar
 * with empty arguments for Asset Category view
 */
const AssetCategoryType = () => {
  return (
    <GraphViewControlBar chartType={ChartType.ASSET_CATEGORY} viewAll />
  );
};

export default AssetCategoryType;
